{
  "navbar": {
    "signedInAs": "目前登入身分",
    "logout": "登出"
  }
}
